import React from "react";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";

const NavItems = ({title, content, onClose}) => {
  const handleAction = () => {
    if(title === "NavItems_column"){onClose()}
  }
    return (
      <Box
        sx={{
            display: "flex",
             flexDirection: title === "NavItems_column" ? 'column' : 'row',
    }}
      >
        {content.map((item) => (
                <a href={`#${item}`} key={item}><Button key={item} sx={{fontSize: title === "NavItems_column" ? '3rem;' : '1.5rem'}} onClick={handleAction}>
                  {item}
                </Button></a>
              ))}
      </Box>
    );
  };

export default NavItems;